'use strict';
var global = require('../internals/global');
var path = require('../internals/path');

module.exports = function (CONSTRUCTOR, METHOD) {
  var Namespace = path[CONSTRUCTOR + 'Prototype'];
  var pureMethod = Namespace && Namespace[METHOD];
  if (pureMethod) return pureMethod;
  var NativeConstructor = global[CONSTRUCTOR];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  return NativePrototype && NativePrototype[METHOD];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/get-built-in-prototype-method.js
// module id = 23
// module chunks = 0 1 2 3